var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tabs',{on:{"tab-click":_vm.handleClick},model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_vm._l((_vm.tabList),function(item){return _c('el-tab-pane',{key:item.id,attrs:{"label":item.label,"name":item.name}})}),_vm._t("default",null,{"list":_vm.filterList})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }